export const getHomeAddress = userProfile => {
    const addressFields = [
        'typeOfRoad',
        'nameOfRoad',
        'addressNumber',
        'addressFloorNumber',
        'department',
        'postalCode',
        'town',
        'province',
        'country',
    ];

    return addressFields.reduce((homeAddress, field) => {
        if (userProfile[field]) {
            homeAddress[field] = userProfile[field];
        }

        return homeAddress;
    }, {});
};
